// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"d21c8bf9","498":"c0cda8c8","703":"2de51629","787":"75bbcf29"}[chunkId] + ".chunk.js";
};